import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import QuotesCard from './QuotesCard';
import MessagesCard from './MessagesCard';
import InvoicesCard from './InvoicesCard';
import DashboardTabs, { useDashboardTab } from '../../components/shared/DashboardTabs';
import TabPanels from '../../components/shared/TabPanels';
import { watchUnreadForClient } from '../../utils/messages';
import { getClient } from '../../utils/clients';
import * as ds from '../../constants/dashboardStyles';

const styles = {
  page: ds.page,
  container: ds.container,
  header: ds.header,
  headerTitle: ds.headerTitle,
  headerSubtitle: ds.headerSubtitle,
  button: ds.secondaryButton,
};

export default function AccountScreen() {
  const { user, logOut } = useAuth();
  const [active, setActive] = useDashboardTab('quotes');
  const [unreadCount, setUnreadCount] = useState(0);
  const [me, setMe] = useState(null);

  // The client's own record — the rules allow reading this one document, so we
  // can greet them by name rather than by email address.
  useEffect(() => {
    if (!user?.email) return;
    getClient(user.email).then(setMe).catch(() => setMe(null));
  }, [user?.email]);

  useEffect(() => {
    if (!user?.email) return undefined;
    return watchUnreadForClient(
      user.email,
      (messages) => setUnreadCount(messages.filter((m) => m.from === 'admin').length),
      () => setUnreadCount(0),
    );
  }, [user?.email]);

  const tabs = [
    { id: 'quotes', label: 'Quotes' },
    { id: 'invoices', label: 'Invoices' },
    { id: 'messages', label: 'Ask a question', count: unreadCount },
  ];

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <div>
            <p style={styles.headerTitle}>{me?.name?.trim() || 'Account'}</p>
            <p style={styles.headerSubtitle}>Signed in as {user?.email}</p>
          </div>
          <button type="button" style={styles.button} onClick={logOut}>
            Log out
          </button>
        </div>

        <DashboardTabs tabs={tabs} active={active} onChange={setActive} />

        <TabPanels
          active={active}
          panels={[
            { id: 'quotes', render: () => <QuotesCard /> },
            { id: 'invoices', render: () => <InvoicesCard /> },
            { id: 'messages', render: () => <MessagesCard /> },
          ]}
        />
      </div>
    </div>
  );
}
